module.exports = __webpack_public_path__ + "media/images/home/dashboard-a44f42a4f6fc22d742dff76df3703602.png";